import moment from "moment";

export function hasDailyPlannerTaskStarted(row) {
  if (!row?.from_date) return false;

  const start = moment(
    `${row.from_date} ${row.from_time || "00:00"}`,
    ["DD-MM-YYYY HH:mm", "DD-MM-YYYY H:mm", "DD-MM-YYYY h:mm A", "DD-MM-YYYY hh:mm A"],
    true
  );

  if (!start.isValid()) return false;
  return moment().isSameOrAfter(start);
}

export function extractStudents(payload) {
  if (!payload || typeof payload !== "object") return [];

  const data = payload.data ?? payload;
  const paginated = data?.Paginated_data;

  if (Array.isArray(paginated?.content)) return paginated.content;
  if (Array.isArray(data?.content)) return data.content;
  if (Array.isArray(data)) return data;
  return [];
}

export function extractDailyPlannerContent(payload) {
  if (!payload || typeof payload !== "object") return [];

  const data = payload.data ?? payload;
  const paginated = data?.Paginated_data ?? data;

  if (Array.isArray(paginated?.content)) return paginated.content;
  if (Array.isArray(data?.content)) return data.content;
  if (Array.isArray(data)) return data;
  return [];
}

function toStudentId(value) {
  if (typeof value === "number" || typeof value === "string") {
    const studentId = Number(value);
    return Number.isFinite(studentId) && studentId > 0 ? studentId : null;
  }

  if (!value || typeof value !== "object") return null;

  return toStudentId(value.student_id ?? value.studentId ?? value.id);
}

function extractArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];

  const data = payload.data ?? payload;

  if (Array.isArray(data)) return data;
  if (data && typeof data === "object") {
    if (Array.isArray(data.content)) return data.content;
    if (Array.isArray(data.data)) return data.data;
    if (Array.isArray(data.student_ids)) return data.student_ids;
  }

  if (Array.isArray(payload.content)) return payload.content;
  if (Array.isArray(payload.student_ids)) return payload.student_ids;

  return [];
}

export function extractStudentIds(payload) {
  const seenIds = new Set();

  return extractArray(payload).flatMap((value) => {
    const studentId = toStudentId(value);
    if (studentId == null || seenIds.has(studentId)) return [];

    seenIds.add(studentId);
    return [studentId];
  });
}
